import { auth } from "../firebase";

const API_BASE =
  "https://sellerproxy-898712575285.us-central1.run.app";

/* ==========================================
   AUTH
========================================== */

async function getAuthToken() {

  const user =
    auth.currentUser;

  if (!user) {

    throw new Error(
      "Please sign in first"
    );

  }

  return await user.getIdToken(
    true
  );

}

/* ==========================================
   APPLY
========================================== */

export async function applyForGallery(
  payload
) {

  const user =
    auth.currentUser;

  if (!user) {

    throw new Error(
      "Please sign in first"
    );

  }

  const token =
    await getAuthToken();

  const response =
    await fetch(
      `${API_BASE}/api/gallery/apply`,
      {
        method: "POST",
        headers: {
  "Content-Type":
    "application/json",
  "x-firebase-authorization":
    `Bearer ${token}`
},
        body: JSON.stringify({
          uid: user.uid,
          email:
            user.email || "",
          displayName:
            user.displayName || "",
          ...payload
        })
      }
    );

  let data = {};

  try {

    data =
      await response.json();

  } catch {

    data = {};

  }

  if (!response.ok) {

    throw new Error(
      data?.message ||
      data?.error ||
      "Failed to submit application"
    );

  }

  return data;

}

/* ==========================================
   STATUS
========================================== */

export async function getGalleryStatus(
  uid
) {

  const token =
    await getAuthToken();

  const response =
    await fetch(
      `${API_BASE}/api/gallery/status/${uid}`,
      {
        headers: {
  "X-Firebase-Authorization":
    `Bearer ${token}`
}
      }
    );

  let data = {};

  try {

    data =
      await response.json();

  } catch {

    data = {};

  }

  if (!response.ok) {

    throw new Error(
      data?.message ||
      data?.error ||
      "Failed to fetch status"
    );

  }

  return data;

}

/* ==========================================
   GALLERIES
========================================== */

export async function getGalleries() {

  const token =
    await getAuthToken();

  const response =
    await fetch(
      `${API_BASE}/api/gallery/galleries`,
      {
        headers: {
  "X-Firebase-Authorization":
    `Bearer ${token}`
}
      }
    );

  return await response.json();

}

/* ==========================================
   CATEGORIES
========================================== */

export async function getCategories(
  galleryId
) {

  const token =
    await getAuthToken();

  const response =
    await fetch(
      `${API_BASE}/api/gallery/categories/${galleryId}`,
      {
       headers: {
  "X-Firebase-Authorization":
    `Bearer ${token}`
}
      }
    );

  return await response.json();

}

/* ==========================================
   SUBCATEGORIES
========================================== */

export async function getSubcategories(
  categoryId
) {

  const token =
    await getAuthToken();

  const response =
    await fetch(
      `${API_BASE}/api/gallery/subcategories/${categoryId}`,
      {
        headers: {
  "X-Firebase-Authorization":
    `Bearer ${token}`
}
      }
    );

  return await response.json();

}

/* ==========================================
   PENDING UPLOADS
========================================== */

export async function getPendingUploads() {

  const token =
    await getAuthToken();

  const response =
    await fetch(
      `${API_BASE}/api/gallery/pending-items`,
      {
        headers: {
  "X-Firebase-Authorization":
    `Bearer ${token}`
}
      }
    );

  return await response.json();

}

/* ==========================================
   APPROVE UPLOAD
========================================== */

export async function approveUpload(
  id
) {

  const token =
    await getAuthToken();

  const response =
    await fetch(
      `${API_BASE}/api/gallery/approve-item/${id}`,
      {
        method: "POST",
       headers: {
  "X-Firebase-Authorization":
    `Bearer ${token}`
}
      }
    );

  let data = {};

  try {

    data =
      await response.json();

  } catch {

    data = {};

  }

  if (!response.ok) {

    throw new Error(
      data?.message ||
      data?.error ||
      "Failed to approve upload"
    );

  }

  return data;

}

/* ==========================================
   REJECT UPLOAD
========================================== */

export async function rejectUpload(
  id
) {

  const token =
    await getAuthToken();

  const response =
    await fetch(
      `${API_BASE}/api/gallery/reject-item/${id}`,
      {
        method: "POST",
        headers: {
  "X-Firebase-Authorization":
    `Bearer ${token}`
}
      }
    );

  let data = {};

  try {

    data =
      await response.json();

  } catch {

    data = {};

  }

  if (!response.ok) {

    throw new Error(
      data?.message ||
      data?.error ||
      "Failed to reject upload"
    );

  }

  return data;

}